<template>
  <div v-if="showLogin" class="login-container" :class="{'login-r': platform === 'r'}">
    <div class="login-bg">
      <div class="iframe-content relative">
        <div v-if="platform === 'web'">
          <i class="gjw-iconfont gjw-icon-web_quxiao close-icon" @click="closeDialog"/>
          <iframe :src="signinForWebUrl" frameborder="0" width="1000" height="600" />
        </div>
        <iframe
            v-else-if="softwareCode === 'AppGbr'"
            :src="signinForTeamUrl"
            frameborder="0"
            width="500"
            height="400px"
            style="padding-top: 20px;"
        />
      </div>
      <!--插件登录蒙层-->
      <div v-if="platform !== 'web' && softwareCode !== 'AppGbr' && !ignoreLogin" class="login-mask">
        <template v-if="showRLoginButton">
          <img :src="loginPic" class="login-img" alt="" />
          <el-button v-if="platform==='r'" type="primary" @click="toRLogin">立即登录体验</el-button>
        </template>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapMutations, mapActions } from 'vuex'
import loginPic from '@/assets/image/login_pic@2x.png'
import checkLoginMixin from '@/mixins/checkLoginMixin'
export default {
  name: 'LoginIframe',
  mixins: [checkLoginMixin],
  data() {
    return {}
  },
  computed: {
    ...mapGetters({
      platform: 'platform',
      softwareCode: 'softwareCode',
      softwareVersion: 'softwareVersion',
      showLogin: 'showLogin',
      showRLoginButton: 'showRLoginButton',
    }),
    loginPic() {
      return loginPic
    },
    ignoreLogin() {
      return !!(this.$route.meta && this.$route.meta.ignoreLogin)
    },
    signinForWebUrl() {
      return `${process.env.VUE_APP_GJW_PORTAL_URL}/signinForWeb?dest=${encodeURIComponent(window.location.href)}`
    },
    signinForTeamUrl() {
      return `${process.env.VUE_APP_GJW_PORTAL_URL}/signinForTeam?dest=${encodeURIComponent(window.location.href)}&platform=${this.platform}`
    }
  },
  mounted() {
    window.addEventListener('message', this.receiveMessage, false)
  },
  methods: {
    ...mapMutations({
      setShowRLoginButton: 'setShowRLoginButton',
      setShowLogin: 'setShowLogin',
      setShowUserDetail: 'user/setShowUserDetail'
    }),
    ...mapActions({
      loadUserInfo: 'user/loadUserInfo',
      loadCurrentProject: 'selectionList/loadCurrentProject',
    }),
    async receiveMessage(event) {
      if (!event.data || typeof event.data !== 'string') { return }
      const origin = event.origin
      if (origin !== process.env.VUE_APP_GJW_PORTAL_URL) { return }
      const data = JSON.parse(event.data)
      if (data.login) {
        // 延迟关闭iframe，确保用户中心可以登录成功。
        setTimeout(() => {
          this.setShowLogin(false)
        }, 500)
        // 获取用户信息
        if (await this.checkLogin(data.token)) {
          if (this.platform === 'cs' || this.softwareCode === 'AppGbr') {
            this.$router.push({ name: 'ComponentList', query: this.$route.query })
          } else {
            // 登录后展示用户详细信息的弹窗
            const res = await this.$api.user.getUserDetail()
            if (!res?.infoCompleted) {
              this.setShowUserDetail(true)
            }
          }
        } else {
          this.setShowLogin(true)
        }
      }
      // 打开外链
      if (data.openLink) {
        if (this.platform === 'web') {
          window.open(data.url, '_blank')
        } else {
          this.$desktopClient.NavigateToBrowser(data.url)
        }
      }
    },
    closeDialog() {
      this.setShowLogin(false)
    },
    async toRLogin() {
      this.setShowRLoginButton(false)
      await this.showLoginDialog()
    }
  }
}
</script>

<style lang="less">
.login-container{
  width: 100vw;
  height: 100vh;
  position: absolute;
  left:0;
  top:0;
  z-index: 10;
  &.login-r{
    padding: 0 24px;
  }
  .login-bg{
    display: flex;
    align-items: center;
    justify-content: center;
    height: 100%;
    background: rgba(0, 0, 0, 0.6);
  }
  .iframe-content{
    background: #FFFFFF;
    overflow: hidden;
  }
  .login-mask{
    width: 100vw;
    height: 100vh;
    position: fixed;
    z-index: 2000;
    left:0;
    top: 0;
    background: rgba(0, 0, 0, 0.6);
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }
  .login-img{
    max-width: 400px;
  }
  .close-icon{
    cursor: pointer;
    font-size: 16px;
    position: absolute;
    right: 10px;
    top: 10px;
  }
}
.login-dialog{
  .el-dialog__body{
    margin-top: -30px;
    padding: 0;
  }
  .el-dialog__headerbtn{
    top: 10px;
    right: 10px;
    font-size: 20px;
  }
}
</style>
